import '../core/polyfills.js';
import $ from 'jquery';
import Highcharts from 'highcharts';
import {patch} from '../core/helpers.js';
import {convertFormatters, addHeaderFooterFormatterSupport} from './dsibhighcharts-formatter.js';
import createJQueryExtension from '../core/dataviz-helpers';
import './dsibhighcharts-print.js';
import './dsibhighcharts-export.js';
import './dsibhighcharts-treemap.js';

function initChart(element, options, config) {
      var container = $('<div></div>').addClass('dsib-highcharts');

      if (options.global || options.lang) {
         var globalOptions = {};
         if (options.global) {
            globalOptions.global = options.global;
            delete options.global;
         }
         if (options.lang) {
            globalOptions.lang = options.lang;
            delete options.lang;
         }
         Highcharts.setOptions(globalOptions);
      }

      addHeaderFooterFormatterSupport(config);

      convertFormatters(config, {
         enabled: !config.chart || !config.chart.hasOwnProperty('dictionary') || config.chart.dictionary,
         enabledAltLabel: !!config.chart && !!config.chart.dictionary && !!config.chart.dictionary.alternativeLabel,
         overrides: config.chart && config.chart.dictionary && config.chart.dictionary.overrides
      });

      element.append(container);

      return Highcharts.chart(container[0], Highcharts.merge(options, config));
}

$.fn.dsibhighcharts = createJQueryExtension('highcharts', initChart, 'chart', 'data');

// !!! WARNING !!! This patch is only compatible with Highcharts 8.1.0 !!!
// Fix an issue where linked axis, not only link the extremes but also the reverse / not reverse state of the axe
Highcharts.Axis.prototype.translate = patch(Highcharts.Axis.prototype.translate, 'var P=Highcharts.isNumber;', {'r.reversed':'this.reversed'});

